<mat-toolbar color="primary">
  <span class="menu-spacer"></span>
  <button mat-button [routerLink]="'/dashboard'">
    <mat-icon>dashboard</mat-icon> Dashboard
  </button>
    <div *ngFor="let appitem of appitems;">
      <ng-container *ngIf="appitem.items;else second">
        <button mat-button [matMenuTriggerFor]="menu"><mat-icon>{{appitem.icon}}</mat-icon> {{appitem.label}}<mat-icon>keyboard_arrow_down</mat-icon></button>
        <mat-menu #menu="matMenu">
          <div *ngFor="let item of appitem.items;">
            <button mat-menu-item [routerLink]="item.link"><mat-icon>{{appitem.icon}}</mat-icon> {{item.label}}</button>
          </div>
        </mat-menu>
      </ng-container>
      <ng-template #second>
          <ng-container>
            <button mat-button [routerLink]="appitem.link"><mat-icon>{{appitem.icon}}</mat-icon> {{appitem.label}}</button>
          </ng-container>
      </ng-template>
    </div>
  <span class="example-spacer"></span>
  <button mat-icon-button [matMenuTriggerFor]="menu1" class="btnclass" style="position: absolute;right: 10px;">
    <img src="http://futurepro.anudip.org/school/assets/male.png" class="external">
  </button>

  <mat-menu #menu1="matMenu" class="toolbar-dropdown-menu user-menu" style="padding-top: 0px !important;">
  
    <mat-card fxLayout="row" fxLayoutAlign="none center  " class="user-info p-0" style="padding: 5px 15px 5px 15px !important;">
        <img src="http://futurepro.anudip.org/school/assets/male.png" class="user-info_img" alt="user-image">
        <div class="left-padd-1" fxLayout="column"  >
            <h2 class="user-info-h2" style="font-size: 16px;font-weight: 500;margin-bottom: 0 !important;">{{ userDetails.userDetails.member.first_name }} {{ userDetails.userDetails.member.last_name }}</h2>
            <h3 class="user-info-h3" style="color: #006064 !important;font-size: 14px;font-weight: 500;margin-bottom: 0 !important;">{{ userDetails.userDetails.member.designation }}</h3>
            <p class="secondary-text-color">Member since : {{userDetails.userDetails.member.start_date | date: 'MMMM d, y'}}</p>
        </div>
    </mat-card>
    <mat-divider></mat-divider>
        <!-- <button mat-menu-item type="button">
          <mat-icon>person</mat-icon>
          <span>Profile</span>
        </button>
        <mat-divider></mat-divider> -->
        <button mat-menu-item (click)="password()">
          <mat-icon>update</mat-icon>
          <span>Change Password</span>
        </button>
        <mat-divider></mat-divider>
        <mat-divider></mat-divider>
        <button mat-menu-item type="button" (click)="logout()">
          <mat-icon>power_settings_new</mat-icon>
          <span>Logout</span>
        </button>

  </mat-menu>
</mat-toolbar>